import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-label="漫画分类导航">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
              Categories
            </span>
            <h2 className="text-2xl md:text-4xl font-display font-bold text-foreground-950 mt-2">
              探索分类
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            无论你喜欢什么类型的漫画，这里都能找到属于你的故事
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-100/60 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">
                {cat.count}部
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}